import {post, get, put, download} from '@/utils/request';

export const orderList = (data) => get('/finance/order/page', data)
export const orderSubmit = (data) => post('/finance/order/submit', data)
export const orderReject = (data) => post('/finance/order/reject', data)
export const orderDetail = (id) => get(`/finance/order/detail/${id}`, null)
export const SetRemark = (body) => post(`/finance/order/set/remark`, body)
export const order = {list: orderList, orderSubmit, orderReject, detail: orderDetail, SetRemark}

export const remitList = (data) => get('/finance/remit/page', data)
export const remitEnsure = (data) => post('/finance/remit/ensure', data)
export const remitReject = (data) => post('/finance/remit/reject', data)
export const remitDetail = (id) => get(`/finance/remit/detail/${id}`, null)
export const remitExport = data => post('/finance/remit/export', data)
export const RemitSetRemark = data => post('/finance/remit/set/remark', data)
export const remit = {
    list: remitList,
    remitReject,
    remitEnsure,
    detail: remitDetail,
    exportApi: remitExport,
    RemitSetRemark
}

export const statementPage = data => get('/finance/statement/financial/page', data);
export const financialAdd = (data) => post('/finance/statement/financial/add', data);
export const financialDel = ids => post('/finance/statement/financial/del', ids);
export const financialEdit = ids => put('/finance/statement/financial/edit', ids);
export const statementDetail = data => get('/finance/statement/detail', data);
export const statementBb = (params) => get('/finance/statement/bb', params);


export const statementExport = (year) => download(`/finance/statement/export?year=${year}`);

// 应收审核
export const ysAudit = {
    list: (data) => get('/finance/receivable/page', data),
    detail: (id) => get(`/finance/receivable/detail/${id}`, null),
    submit: (data) => post('/finance/receivable/tg', data),
    reject: (data) => post('/finance/receivable/reject', data),
    exportApi: data => post('/finance/receivable/export', data),
}
// 员工工资
export const empWageAudit = {
    list: (data) => get('/finance/empwage/page', data),
    detail: (id) => get(`/finance/empwage/detail/${id}`, null),
    submit: (data) => post('/finance/empwage/tg', data),
    reject: (data) => post('/finance/empwage/reject', data),
    exportApi: data => post('/finance/empwage/export', data),
}
